import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import Servicehero from '../components/Service/Servicehero'
import Service from '../components/Service/Service'
import Footerhero from '../components/Footer/Footerhero'

import ServiceList from '../components/Service/ServiceList'
import AppointmentSection from '../components/Service/AppointmentSection'
import Enquiryform from '../components/Service/Enquiryform'


const Servicepage = () => {
    return (
        <div>
        <Navbar/>
        <Servicehero/>
        <Service/>
        <ServiceList/>
        <AppointmentSection/>
        <Enquiryform/>
    
        <Footerhero/>
        



        <Footer/>
        </div>
    )
}

export default Servicepage